import React from "react";
import { Box, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: "40px",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      width: "100%",
      fontSize: "12px",
    },
  },
  tabPanel: {
    display: "block",
    position: "relative",
  },
}));

interface LinkTabProps {
  label?: string;
  href?: string;
  disabled?: boolean;
}

function LinkTab({ label, href, disabled }: LinkTabProps): React.ReactElement {
  const classes = useStyles();
  return (
    <Tab
      component="a"
      className={classes.indicator}
      style={{ minWidth: "76px", height: "40px" }}
      label={label}
      href={href}
      disabled={disabled}
    />
  );
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: string | number;
  width?: number;
  className?: string;
}

export function TabPanel({ children, value, index, ...other }: TabPanelProps): React.ReactElement {
  const classes = useStyles();
  return (
    <div
      role="tabpanel"
      hidden={+value !== index}
      aria-labelledby={`tab-${index}`}
      {...other}
      className={clsx(+value === +index && classes.tabPanel)}
    >
      {+value === +index && <Box height={1}>{children}</Box>}
    </div>
  );
}

export function LoadingTab(): React.ReactElement {
  return <Skeleton variant="rect" width={315} height={1} />;
}

export default LinkTab;
